import { createFileRoute, Link } from "@tanstack/react-router";
import { useMe } from "@/lib/auth";
import { t } from "@/i18n";

export const Route = createFileRoute("/")({
  component: HomePage,
});

function HomePage() {
  const { data: me, isLoading } = useMe();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-muted">
      <header className="border-b">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <span className="text-xl font-semibold">{t("app.name")}</span>
          <nav className="flex items-center gap-3">
            {isLoading ? null : me ? (
              <Link
                to="/app/dashboard"
                className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
              >
                {t("nav.assignments")}
              </Link>
            ) : (
              <Link
                to="/sign-in"
                className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
              >
                {t("home.cta")}
              </Link>
            )}
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-20">
        <div className="text-center">
          <h1 className="text-5xl font-bold tracking-tight text-foreground sm:text-6xl">
            {t("home.title")}{" "}
            <span className="text-primary">{t("types.HW-DICTATE")}</span>.
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground">
            {t("home.subtitle")}
          </p>
          <div className="mt-10">
            <Link
              to="/sign-in"
              className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-base font-medium text-primary-foreground hover:bg-primary/90"
            >
              {me ? t("nav.assignments") : t("home.cta")}
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
